module.exports = __webpack_public_path__ + "img/Goyang.17303e37.svg";